import { lazy, Suspense, useEffect } from 'react';
/// Components
import Index from './jsx/index';
import { useDispatch, useSelector } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
/// Style
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

import LandingPage from './jsx/pages/landing/Landing';
import ForgotPassword from './jsx/pages/ForgotPassword';

import Objectifs from './jsx/pages/Authentication/objectifs/Objectifs';
import OTPValidationPage from './jsx/pages/Authentication/otp_verify/otpVerify';
import { createSelector } from '@reduxjs/toolkit';
import Verifiedemail from './jsx/pages/Authentication/password/Verifiedemail';
import Resetemail from './jsx/pages/Authentication/password/Resetemail';
import Loading from './jsx/components/loading';
import SendNewPassword from './jsx/pages/Authentication/password/sendNewPassword';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
//const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
/* const Login = lazy(() => {
    return new Promise(resolve => {
		setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
	});
}); */
const LoginPage = lazy(() => {
    return new Promise(resolve => {
		setTimeout(() => resolve(import('./jsx/pages/Authentication/login/Login')), 500);
	});
});


function withRouter(Component) {
    function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      
      return (
        <Component
          {...props}
          router={{ location, navigate, params }}
        />
      );
    }
  
    return ComponentWithRouterProp;
  }

function App (props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectLayoutState = (state) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Login.user,
isAuthenticated: state.Login.isAuthenticated,
          
   })
    ); 
 // Inside your component
const {
       isAuthenticated
  } = useSelector(loginpageData); 

 
  useEffect(() => {
    checkAutoLogin(dispatch, navigate);
    }, [dispatch]);
    
    let routes = (  
        <Routes>
            {/* <Route index element={<LandingPage />} /> */}
            <Route path='/landing' element={<LandingPage />} />
            <Route path='/otp' element={<OTPValidationPage />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/objectifs' element={<Objectifs />} />
            <Route path='/page-register' element={<SignUp />} />
            <Route path='/page-forgot-password' element={<ForgotPassword />} />
            <Route path='/Verifiedemail' element={<Verifiedemail />} />
            <Route path='/sendNewPassword-password' element={<SendNewPassword />} />

            <Route path='/Resetemail' element={<Resetemail />} />
            {/* <Route path='*' element={<LandingPage />} /> */}
        </Routes>
    );
    if (isAuthenticated) {
		return (
			<>
                <Suspense fallback={
                   <Loading/>
                   }
                >
                    <Index />
                </Suspense>
            </>
        );
	
	}else{
		return (
			<div className="vh-100">
                <Suspense fallback={
                    <Loading/>
                  }
                >
                   {routes}
                </Suspense>
			</div>
		);
	}
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.isAuthenticated,
    };
};

export default App; 
